(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
function closeNaladirseBag(bag){if(!bag||bag.classList.contains('closing'))return;bag.classList.add('closing');setTimeout(()=>{bag.close();bag.classList.remove('closing');document.body.style.overflow=''},matchMedia('(prefers-reduced-motion: reduce)').matches?0:220)}
document.addEventListener('click',event=>{const bag=document.getElementById('cart');if(!bag)return;if(event.target.closest('[data-open-bag]')){event.preventDefault();bag.classList.remove('closing');if(!bag.open)bag.showModal();document.body.style.overflow='hidden'}if(event.target.closest('[data-close-bag]'))closeNaladirseBag(bag);if(event.target===bag){const bounds=bag.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)closeNaladirseBag(bag)}});
document.addEventListener('cancel',event=>{if(event.target.id==='cart'){event.preventDefault();closeNaladirseBag(event.target)}},true);
document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('#cart[open]'))document.body.style.overflow=''});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.naladirse-contact-form').forEach(function(form){
  const email=form.querySelector('[name="contact[email]"]');
  const name=form.querySelector('[name="contact[name]"]');
  const message=form.querySelector('[name="contact[body]"]');
  const trap=form.querySelector('[name="contact[website]"]');
  const error=form.querySelector('.contact-client-error');
  if(!email||!message||!trap||!error)return;
  const link=/(?:https?:\/\/|www\.|\b[a-z0-9-]+\.(?:com|cl|net|org|io|co|shop|store|app|info|es|me|xyz|link|ly|site)\b|\b(?:t\.me|wa\.me)\/)/i;
  const show=function(field,text){error.textContent=text;error.hidden=false;field.setCustomValidity(text);field.reportValidity();field.focus()};
  [email,name,message].forEach(function(field){if(field)field.addEventListener('input',function(){field.setCustomValidity('');error.hidden=true})});
  message.addEventListener('paste',function(event){if(event.clipboardData&&event.clipboardData.files.length){event.preventDefault();show(message,'No se permiten archivos adjuntos.')}});
  message.addEventListener('drop',function(event){if(event.dataTransfer&&event.dataTransfer.files.length){event.preventDefault();show(message,'No se permiten archivos adjuntos.')}});
  form.addEventListener('submit',function(event){
    email.value=email.value.trim();
    if(name)name.value=name.value.trim();
    message.value=message.value.trim();
    const parts=email.value.split('@');
    if(parts.length!==2||!parts[0]||parts[0].includes('..')||parts[1].includes('..')||!/^\S+\.\S{2,}$/.test(parts[1])||/\s/.test(email.value)){event.preventDefault();show(email,'Escribe una dirección de correo válida.');return}
    if(trap.value.trim()){event.preventDefault();error.textContent='No se pudo enviar el mensaje. Inténtalo nuevamente.';error.hidden=false;return}
    if(link.test(message.value)||name&&link.test(name.value)){event.preventDefault();show(message,'El mensaje no puede contener enlaces.');return}
    if(message.value.length<10){event.preventDefault();show(message,'Escribe al menos 10 caracteres en tu consulta.');return}
    error.hidden=true;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
function initFeaturedCarousels(root=document){
  root.querySelectorAll('[data-catalog]').forEach(catalog=>{
    const track=catalog.querySelector('[data-carousel-track]');
    if(!track||catalog.dataset.carouselReady)return;
    catalog.dataset.carouselReady='true';
    const controller=new AbortController();
    const on=(target,name,handler,options={})=>target.addEventListener(name,handler,{...options,signal:controller.signal});
    const originals=[...track.querySelectorAll('[data-product-type]')];
    const visible=()=>originals.filter(card=>!card.hidden);
    const position=card=>card.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft;
    const previous=catalog.querySelector('[data-carousel-previous]');
    const next=catalog.querySelector('[data-carousel-next]');
    const controls=catalog.querySelector('.carousel-controls');
    const filters=catalog.querySelector('[data-native-filters]');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const duration=Math.max(160,Math.min(360,Number(catalog.dataset.motionDuration)||240));
    let frame=0,settleTimer,timer,goal=null,motionPosition=null,dragging=false,inView=false;
    let stops=[0],maximum=0,canScroll=false;
    const update=()=>{
      const left=track.scrollLeft;
      catalog.dataset.carouselEdge=left<=2?'start':left>=maximum-2?'end':'middle';
    };
    const stop=()=>{cancelAnimationFrame(frame);frame=0;goal=null;motionPosition=null;track.style.scrollSnapType='';delete track.dataset.animating};
    const pause=()=>{clearInterval(timer);timer=undefined};
    const resume=()=>{
      pause();
      if(!canScroll||track.scrollLeft>=maximum-2||!inView||dragging||reduced.matches||document.hidden||catalog.dataset.autoplay!=='true'||catalog.matches(':hover')||catalog.contains(document.activeElement))return;
      timer=setInterval(()=>move(1,false),Math.max(3000,Number(catalog.dataset.interval)||5000));
    };
    const settle=()=>{if(frame||dragging)return;update();resume()};
    const build=(preserve=true)=>{
      const oldLeft=preserve?track.scrollLeft:0;
      stop();pause();clearTimeout(settleTimer);
      track.style.scrollSnapType='none';
      const items=visible();
      maximum=Math.max(0,track.scrollWidth-track.clientWidth);
      canScroll=maximum>2;
      stops=[0,...items.map(card=>Math.max(0,Math.min(maximum,position(card)-(items.length?position(items[0]):0)))),maximum].filter((value,index,array)=>index===0||value-array[index-1]>2);
      previous.disabled=next.disabled=!canScroll;
      controls.hidden=items.length===0;
      track.tabIndex=canScroll?0:-1;
      track.scrollLeft=Math.min(maximum,oldLeft);
      update();
      requestAnimationFrame(()=>{if(!frame)track.style.scrollSnapType=''});
      resume();
    };
    const move=(direction,wrap=true)=>{
      if(!canScroll)return;
      pause();
      const from=motionPosition??track.scrollLeft,reference=goal??from;
      let target;
      if(direction>0)target=reference>=maximum-2?(wrap?0:maximum):(stops.find(value=>value>reference+2)??maximum);
      else target=reference<=2?(wrap?maximum:0):(stops.findLast(value=>value<reference-2)??0);
      cancelAnimationFrame(frame);
      track.style.scrollSnapType='none';goal=target;
      const finish=()=>{track.scrollLeft=target;frame=0;goal=null;motionPosition=null;track.style.scrollSnapType='';delete track.dataset.animating;update();resume()};
      if(reduced.matches){finish();return}
      const started=performance.now();track.dataset.animating='true';
      const tick=now=>{
        const progress=Math.min(1,(now-started)/duration);
        motionPosition=from+(target-from)*(1-Math.pow(1-progress,3));track.scrollLeft=motionPosition;
        if(progress<1){frame=requestAnimationFrame(tick);return}finish();
      };
      frame=requestAnimationFrame(tick);
    };
    on(previous,'click',()=>move(-1));on(next,'click',()=>move(1));
    on(track,'keydown',event=>{if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();move(event.key==='ArrowRight'?1:-1)});
    if(filters)filters.hidden=false;
    catalog.querySelectorAll('[data-category]').forEach(button=>on(button,'click',()=>{
      catalog.querySelectorAll('[data-category]').forEach(item=>{item.classList.toggle('active',item===button);item.setAttribute('aria-pressed',String(item===button))});
      originals.forEach(card=>{card.hidden=!!button.dataset.category&&card.dataset.productType!==button.dataset.category});
      build(false);
    }));
    on(track,'pointerdown',()=>{dragging=true;stop();pause()},{passive:true});
    on(document,'pointerup',()=>{if(!dragging)return;dragging=false;clearTimeout(settleTimer);settleTimer=setTimeout(settle,140)},{passive:true});
    on(document,'pointercancel',()=>{if(!dragging)return;dragging=false;settleTimer=setTimeout(settle,140)},{passive:true});
    on(track,'wheel',()=>{stop();pause()},{passive:true});
    on(track,'scroll',()=>{if(!frame)update();if(frame||dragging)return;clearTimeout(settleTimer);settleTimer=setTimeout(settle,160)},{passive:true});
    on(track,'scrollend',settle);
    on(catalog,'mouseenter',pause);on(catalog,'mouseleave',resume);
    on(catalog,'focusin',pause);on(catalog,'focusout',()=>requestAnimationFrame(resume));
    on(document,'visibilitychange',()=>{if(document.hidden)stop();resume()});
    on(reduced,'change',()=>{stop();settle()});
    let width=track.clientWidth;
    const resize=new ResizeObserver(()=>{if(Math.abs(track.clientWidth-width)<1)return;width=track.clientWidth;build()});
    resize.observe(track);
    const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;resume()},{threshold:.1});
    observer.observe(track);
    on(document,'shopify:section:unload',event=>{if(!event.target.contains(catalog))return;stop();pause();clearTimeout(settleTimer);resize.disconnect();observer.disconnect();controller.abort()});
    build(false);
  });
}
initFeaturedCarousels();
document.addEventListener('shopify:section:load',event=>initFeaturedCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if(!customElements.get('naladirse-announcements')){
  customElements.define('naladirse-announcements',class extends HTMLElement{
    connectedCallback(){
      this.slides=Array.from(this.querySelectorAll('.announcement__slide'));
      if(this.slides.length<2)return;
      this.index=Number(this.dataset.index)||0;
      this.hovered=false;
      this.schedule=()=>{
        window.clearTimeout(this.timer);
        if(!this.isConnected||document.hidden||this.hovered)return;
        this.timer=window.setTimeout(()=>{
          this.index=(this.index+1)%this.slides.length;
          this.dataset.index=String(this.index);
          this.slides.forEach((slide,index)=>slide.setAttribute('aria-hidden',String(index!==this.index)));
          this.schedule();
        },4500);
      };
      this.onEnter=event=>{
        if(event.pointerType!=='mouse')return;
        this.hovered=true;
        window.clearTimeout(this.timer);
      };
      this.onLeave=()=>{this.hovered=false;this.schedule();};
      this.addEventListener('pointerenter',this.onEnter);
      this.addEventListener('pointerleave',this.onLeave);
      document.addEventListener('visibilitychange',this.schedule);
      this.schedule();
    }
    disconnectedCallback(){
      window.clearTimeout(this.timer);
      this.removeEventListener('pointerenter',this.onEnter);
      this.removeEventListener('pointerleave',this.onLeave);
      if(this.schedule)document.removeEventListener('visibilitychange',this.schedule);
    }
  });
}
function watchNaladirseHeader(root=document){
  const header=root.querySelector('.site-header-shell');
  if(!header||header.dataset.sizeReady)return;
  header.dataset.sizeReady='true';
  const update=()=>document.documentElement.style.setProperty('--header-height',(getComputedStyle(header).position==='sticky'?Math.ceil(header.getBoundingClientRect().height):0)+'px');
  const observer=new ResizeObserver(update);observer.observe(header);update();
  window.addEventListener('resize',update,{passive:true});
  document.addEventListener('shopify:section:unload',function cleanup(event){if(!event.target.contains(header))return;observer.disconnect();window.removeEventListener('resize',update);document.documentElement.style.removeProperty('--header-height');document.removeEventListener('shopify:section:unload',cleanup)});
}
watchNaladirseHeader();
document.addEventListener('shopify:section:load',event=>watchNaladirseHeader(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function warmGalleryNeighbors(gallery,index){
  const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
  if(slides.length<2)return;
  for(const offset of [1,-1]){
    const image=slides[(index+offset+slides.length)%slides.length].querySelector('img');
    if(image){image.fetchPriority='low';image.loading='eager'}
  }
}
function revealGalleryThumbnail(gallery,index,animate=false){
  const strip=gallery.querySelector('.gallery-thumbnails');
  const thumb=gallery.querySelectorAll('[data-gallery-thumb]')[index];
  if(!strip||!thumb)return;
  const bounds=strip.getBoundingClientRect(),target=thumb.getBoundingClientRect();
  if(target.left>=bounds.left&&target.right<=bounds.right)return;
  const left=strip.scrollLeft+target.left-bounds.left-(strip.clientWidth-target.width)/2;
  strip.scrollTo({left,behavior:animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
}
function initializeGallery(gallery){
  if(gallery.dataset.galleryReady)return;
  gallery.dataset.galleryReady='true';
  const initial=Number(gallery.dataset.initialIndex||0);
  gallery.dataset.current=String(initial);
  requestAnimationFrame(()=>revealGalleryThumbnail(gallery,initial));
  const first=gallery.querySelectorAll('[data-gallery-slide]')[initial]?.querySelector('img');
  if(!first)return;
  if(first.complete&&first.naturalWidth)warmGalleryNeighbors(gallery,initial);
  else first.addEventListener('load',()=>warmGalleryNeighbors(gallery,Number(gallery.dataset.current||0)),{once:true});
}
function initializeGalleries(root=document){root.querySelectorAll('[data-gallery]').forEach(initializeGallery)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeGalleries(),{once:true});
else initializeGalleries();
document.addEventListener('shopify:section:load',event=>initializeGalleries(event.target));
async function selectGalleryImage(gallery,index,direction=0){
  const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
  if(!slides.length)return;
  const current=Number(gallery.dataset.current||0);
  index=(index+slides.length)%slides.length;
  const ticket=Number(gallery.dataset.selectionToken||0)+1;
  gallery.dataset.selectionToken=String(ticket);
  const stage=gallery.querySelector('.gallery-stage');
  if(index===current){
    delete gallery.dataset.pending;
    stage.classList.remove('is-loading');
    stage.removeAttribute('aria-busy');
    return;
  }
  gallery.dataset.pending=String(index);
  stage.classList.add('is-loading');
  stage.setAttribute('aria-busy','true');
  const incoming=slides[index];
  const image=incoming.querySelector('img');
  image.fetchPriority='high';
  image.loading='eager';
  try{await image.decode()}catch(error){}
  if(Number(gallery.dataset.selectionToken)!==ticket)return;
  delete gallery.dataset.pending;
  stage.classList.remove('is-loading');
  stage.removeAttribute('aria-busy');
  if(!image.naturalWidth)return;
  if(gallery._galleryFinish)gallery._galleryFinish();
  const outgoing=slides[Number(gallery.dataset.current||0)];
  const shift=(direction||Math.sign(index-current))*14;
  stage.style.setProperty('--gallery-shift',shift+'px');
  stage.style.setProperty('--gallery-out-shift',Math.round(-shift*.35)+'px');
  incoming.hidden=false;
  gallery.dataset.current=String(index);
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));
  revealGalleryThumbnail(gallery,index,true);
  const counter=gallery.querySelector('[data-gallery-index]');
  if(counter)counter.textContent=String(index+1);
  if(outgoing!==incoming){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      outgoing.hidden=true;
    }else{
      let timeout;
      let finished=false;
      const onEnd=event=>{if(event.target===incoming)finish()};
      const finish=()=>{
        if(finished)return;
        finished=true;
        clearTimeout(timeout);
        incoming.removeEventListener('animationend',onEnd);
        incoming.classList.remove('is-gallery-incoming');
        outgoing.classList.remove('is-gallery-outgoing');
        outgoing.hidden=true;
        if(gallery._galleryFinish===finish)gallery._galleryFinish=null;
      };
      gallery._galleryFinish=finish;
      incoming.addEventListener('animationend',onEnd);
      outgoing.classList.add('is-gallery-outgoing');
      incoming.classList.add('is-gallery-incoming');
      timeout=setTimeout(finish,300);
    }
  }
  warmGalleryNeighbors(gallery,index);
}
document.addEventListener('click',event=>{
  const gallery=event.target.closest('[data-gallery]');
  if(!gallery)return;
  const thumb=event.target.closest('[data-gallery-thumb]');
  const step=event.target.closest('[data-gallery-step]');
  const slide=event.target.closest('[data-gallery-slide]');
  const close=event.target.closest('[data-gallery-close]');
  if(thumb)selectGalleryImage(gallery,Number(thumb.dataset.galleryThumb));
  if(step){
    const amount=Number(step.dataset.galleryStep);
    selectGalleryImage(gallery,Number(gallery.dataset.pending??gallery.dataset.current??'0')+amount,amount);
  }
  const dialog=gallery.querySelector('dialog');
  if(slide){
    window.openNaladirseZoom(dialog,slide);
  }
  if(close||event.target===dialog)dialog.close();
});
document.addEventListener('keydown',event=>{
  const gallery=event.target.closest('[data-gallery]');
  if(!gallery||gallery.querySelector('dialog[open]'))return;
  if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
    event.preventDefault();
    const amount=event.key==='ArrowRight'?1:-1;
    selectGalleryImage(gallery,Number(gallery.dataset.pending??gallery.dataset.current??'0')+amount,amount);
  }
});

document.addEventListener('change',event=>{if(!event.target.matches('[data-variant-select]'))return;const root=event.target.closest('[data-native-product]'),option=event.target.selectedOptions[0],button=root.querySelector('[data-product-submit]'),quantity=root.querySelector('[data-product-quantity]');root.querySelector('[data-variant-price]').textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;const badge=root.querySelector('.product-badge');if(badge)badge.hidden=button.disabled;updateNaladirseQuantity(root);const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);const gallery=root.querySelector('[data-gallery]');if(gallery&&option.dataset.imageId){const index=[...gallery.querySelectorAll('[data-gallery-slide]')].findIndex(slide=>slide.dataset.imageId===option.dataset.imageId);if(index>=0)selectGalleryImage(gallery,index)}});
document.addEventListener('click',event=>{const control=event.target.closest('[data-quantity-change]');if(!control)return;const picker=control.closest('.quantity-picker'),input=picker.querySelector('[data-product-quantity]'),step=Number(input.step)||1,min=Number(input.min)||1,max=input.max===''?Infinity:Number(input.max),current=Number(input.value)||min,next=Math.min(max,Math.max(min,current+Number(control.dataset.quantityChange)*step));input.value=String(next);input.dispatchEvent(new Event('change',{bubbles:true}))});

let galleryGesture=null;
let galleryClickBlock=null;
document.addEventListener('pointerdown',event=>{
  if(event.pointerType!=='touch'&&event.pointerType!=='pen')return;
  if(!event.isPrimary){galleryGesture=null;return}
  const slide=event.target.closest('[data-gallery-slide]');
  if(!slide)return;
  galleryGesture={gallery:slide.closest('[data-gallery]'),x:event.clientX,y:event.clientY,id:event.pointerId};
},{passive:true});
document.addEventListener('pointerup',event=>{
  if(!galleryGesture||event.pointerId!==galleryGesture.id)return;
  const gesture=galleryGesture;galleryGesture=null;
  const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
  if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.3)return;
  const gallery=gesture.gallery;
  if(gallery.querySelectorAll('[data-gallery-slide]').length<2)return;
  galleryClickBlock={gallery,until:performance.now()+350};
  const amount=dx<0?1:-1;
  selectGalleryImage(gallery,Number(gallery.dataset.pending??gallery.dataset.current??0)+amount,amount);
});
document.addEventListener('pointercancel',()=>{galleryGesture=null},{passive:true});
document.addEventListener('click',event=>{
  if(!galleryClickBlock)return;
  const block=galleryClickBlock;galleryClickBlock=null;
  if(performance.now()>block.until||!event.target.closest('[data-gallery-slide]')||event.target.closest('[data-gallery]')!==block.gallery)return;
  event.preventDefault();event.stopImmediatePropagation();
},true);
function updateNaladirseQuantity(root){
  const input=root.querySelector('[data-product-quantity]');
  if(!input)return;
  const min=Number(input.min)||1,max=input.max===''?Infinity:Number(input.max),value=Number(input.value);
  root.querySelectorAll('[data-quantity-change]').forEach(button=>{button.disabled=Number(button.dataset.quantityChange)<0?value<=min:value>=max});
}
document.querySelectorAll('[data-native-product]').forEach(updateNaladirseQuantity);
document.addEventListener('input',event=>{if(event.target.matches('[data-product-quantity]'))updateNaladirseQuantity(event.target.closest('[data-native-product]'))});
document.addEventListener('change',event=>{if(event.target.matches('[data-product-quantity]'))updateNaladirseQuantity(event.target.closest('[data-native-product]'))});
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-native-product]').forEach(updateNaladirseQuantity));

  } catch(e) { console.error(e); }
})();
})();
